import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';

const Page = () => (
  <div className="flex justify-center items-center h-screen w-full">
    <Spinner type={SpinnerType.PRIMARY} />
  </div>
);

export default Page;
